import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';

// Components
import JcPortalSalesOrderHQTable from "./JcPortalSalesOrderHQTable";
//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";

import {PDFDownloadLink} from '@react-pdf/renderer';
import {JcPortalPackageSales} from "../../../components/PDF/JcPortalPackageSales";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MessageBox from "../../../components/MessageBox/MessageBox";
import LoadingModal from "../../../components/Modal/LoadingModal";
//cookies
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import Preloader from "../../../components/Preloader/Preloader";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #59b259",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#c1c3d8",
		display:"none"
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(89, 178, 89, 0.09)",
		padding: "1rem",
		border: "1.5px solid #59b259",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	wayBillbuttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
		marginTop:"1rem !important",
		marginRight:"1rem !important",
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #59b259",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
});

const JcPortalPackageSalesView = () => {
	const { transaction_no, flag } = useParams();
	const [soInfo, setSoInfo] = useState(null);
	const [pkgInfo, setPkgInfo] = useState([]);
	const [activationInfo, setActivationInfo] = useState([]);
	
	const classes = useStyles();

	const [items, setItems] = useState([]); //data to display in item table
	const [showPDF, setShowPdf] = useState(false);

	const [shipping, setShipping] = useState([]);
	const [warehouse, setWarehouse] = useState([]);
	const [shippingId, setShippingId] = useState('');
	const [warehouseId, setWarehouseId] = useState('');

	const [waybillNo, setWaybillNo] = useState('');
	let history = useHistory();
	let total_payment = 0;

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF	
	//state for managing loading modal
	const [showModal, setShowModal] = useState(false);	
	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(true);
	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	const selectShippingProps = {
		options: shipping,
		getOptionLabel: (option) => option.description,
	};

	const selectLocationProps = {
		options: warehouse,
		getOptionLabel: (option) => option.description,
	};

	useEffect(() => {
		if(waybillNo || (shippingId&&warehouseId)){
			setBtnDisabled(false); // re-enable
		}else{
			setBtnDisabled(true); // re-enable	
		}
	}, [waybillNo,shippingId,warehouseId]);

	const data = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'view_packagesales', {
			params:{
				pps_no: transaction_no,
				jc_u_idno: get_cookies('branchidno')
			}
		}).then((res)=>{
			// setItems(res.data.data.cart_summary);
			setSoInfo(res.data.data.tran_details);
			setPkgInfo(res.data.data);
			setActivationInfo(res.data.data.activations);
			setShipping(res.data.data.shipping);
			setWarehouse(res.data.data.warehouses);
			setShowPdf(true);
		}).catch((error)=>{
		//console.log(error.message);
		})
	};	

	const waybill_portal_so = async () => {
		setBtnDisabled(true); // disable button to avoid multiple saves
		setShowModal(true); //show loading/please wait modal
		const formData = new FormData();
		// pps_no:PPS_000000010
		// waybill_no:123456
		formData.append("pps_no", transaction_no);
		formData.append("waybill_no", waybillNo);
		await axios.post(process.env.REACT_APP_API_URL+'waybill_packagesales_process', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
				}
			}).then(function (res) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("Successfully entered WayBill No "+waybillNo);
				setMsgType("success");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
					history.push('/sales/jcpackagesales');
				}, 2000)
		  	}).catch(function (error) {
				setShowModal(false); //hide loading/please wait modal 
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
	  		});
	}

	const release_portal_so = async () => {
		setBtnDisabled(true); // disable button to avoid multiple saves
		setShowModal(true); //show loading/please wait modal
		const formData = new FormData();
		// pps_no:PPS_000000026
		// jc_u_idno:DAVAOHQ
		// username:superuser
		// locid:8
		// shipping_loc:8
		formData.append("pps_no", transaction_no);
		formData.append("jc_u_idno", get_cookies('branchidno'));
		formData.append("username", get_cookies('username'));
		formData.append("locid", warehouseId);
		formData.append("shipping_loc", shippingId);
		await axios.post(process.env.REACT_APP_API_URL+'release_packagesales_process', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
				}
			}).then(function (res) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("Successfully Released Package Sales");
				setMsgType("success");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
					history.push('/sales/jcportalsales');
				}, 2000)
		  	}).catch(function (error) {
				setShowModal(false); //hide loading/please wait modal 
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
	  		});
	}

	const deliver_portal_so = async () => {
		setBtnDisabled(true); // disable button to avoid multiple saves
		setShowModal(true); //show loading/please wait modal
		const formData = new FormData();
		formData.append("pps_no", transaction_no);
		await axios.post(process.env.REACT_APP_API_URL+'deliver_packagesales_process', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
				}
			}).then(function (res) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("Successfully changed status to delivered");
				setMsgType("success");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
					history.push('/sales/jcpackagesales');
				}, 2000)
		  	}).catch(function (error) {
				setShowModal(false); //hide loading/please wait modal 
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
	  		});
	}
	
	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<NavLink to={"/sales"}><h4 style={{color:"#339933"}}>Sales</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<NavLink to={"/sales/jcpackagesales"}><h4 style={{color:"#339933"}}>Jc Portal Package Sales</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>{transaction_no}</h4>
			</div>
			{soInfo ? (			<div className="page-container">
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<LoadingModal showModal={showModal}/>
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={12} sm={8}>
								<div className={classes.subTitle}>
								Package Sales View
								</div>
								<div className={classes.title}>
								Package Sales View
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>
							</Grid>
					  </Grid>
					</div>
					<CardContent>
						<Grid container spacing={3}>
							{flag==='waybill' ? (<Grid item xs={12}>
								<Grid container spacing={0}>
										<Grid item xs={12} sm={6} md={6} lg={3}>
											<TextField
												style={{marginTop:"8px"}}
												id="outlined-required"
												label="Enter Waybill"
												fullWidth={true}
												variant="outlined"
												className={classes.field}
												value={waybillNo} //to avoid label overlapping bug
												onChange={(e)=>{setWaybillNo(e.target.value)}}
											/>	
										</Grid>	
										<Grid item xs={12} sm={6} md={6} lg={3} xl={2}>
											<div className={classes.wayBillbuttonContainer}>
												<Button variant="contained" disabled={btnDisabled}  onClick={()=>{waybill_portal_so()}} color="primary">Enter Waybill</Button>
												<Button  onClick={()=>{history.push('/sales/jcportalsales')}} variant="contained">Back</Button>
											</div>
										</Grid>	
								</Grid>
							</Grid>) : (<></>)}
							<Grid item xs={12} sm={6}>
							<h4>Transaction Details</h4>
							<div className={classes.infoContainer}>
								<Grid container spacing={3}>
									<Grid item xs={12} sm={4} className={classes.infoTitle}>
										Sold To: 
									</Grid>
									<Grid
										item
										xs={12} sm={8}
										className={classes.infoContent}
									>
										{soInfo.delivered_to || "Sold To"}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={12} sm={4} className={classes.infoTitle}>
										Transaction Ref No:
									</Grid>
									<Grid
										item
										xs={12} sm={8}
										className={classes.infoContent}
									>
										{soInfo.transaction_no || "Transaction Ref No"}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={12} sm={4} className={classes.infoTitle}>
										Transaction Date:
									</Grid>
									<Grid
										item
										xs={12} sm={8}
										className={classes.infoContent}
									>
										{soInfo.trandate || "Trandate"}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={12} sm={4} className={classes.infoTitle}>
										Package Amount:
									</Grid>
									<Grid
										item
										xs={12} sm={8}
										className={classes.infoContent}
									>
										{numeral(soInfo.package_amount).format('0,0.00')}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={12} sm={4} className={classes.infoTitle}>
										Shipping Fee:
									</Grid>
									<Grid
										item
										xs={12} sm={8}
										className={classes.infoContent}
									>
										{numeral(soInfo.shipping_fee).format('0,0.00')}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={12} sm={4} className={classes.infoTitle}>
										Grand Total:
									</Grid>
									<Grid
										item
										xs={12} sm={8}
										className={classes.infoContent}
									>
										{numeral(pkgInfo.grand_total).format('0,0.00')}
									</Grid>
								</Grid>
							</div>



							<h4>Payment Details</h4>
								<div className={classes.infoContainer}>
									<Grid container spacing={3}>
										<Grid item xs={12} sm={4} className={classes.infoTitle}>
											Payment Status:
										</Grid>
										<Grid
											item
											xs={12} sm={8}
											className={classes.infoContent}
										>
											{pkgInfo.ispaid}
										</Grid>
									</Grid>
									<Grid container spacing={3}>
										<Grid item xs={12} sm={4} className={classes.infoTitle}>
											Payment Ref No:
										</Grid>
										<Grid
											item
											xs={12} sm={8}
											className={classes.infoContent}
										>
											{pkgInfo.refno}
										</Grid>
									</Grid>
									{soInfo.card_payment_amt > 0 ? (<Grid container spacing={3}>
										{soInfo.payment_mode === 1 ? (<Grid item xs={12} sm={4} className={classes.infoTitle}>
											Paypanda Payment:
										</Grid>) : (<Grid item xs={12} sm={4} className={classes.infoTitle}>
											Asiapay Payment:
										</Grid>)}
										<Grid
											item
											xs={12} sm={8}
											className={classes.infoContent}
										>
											{numeral(pkgInfo.grand_total).format('0,0.00')}
										</Grid>
									</Grid>) : (<></>)}

									<Grid container spacing={3}>
										<Grid item xs={12} sm={4} className={classes.infoTitle}>
											Total Payment:
										</Grid>
										<Grid
											item
											xs={12} sm={8}
											className={classes.infoContent}
										>
											{numeral(pkgInfo.grand_total).format('0,0.00')}
										</Grid>
									</Grid>
								</div>


							<h4>Delivery Details</h4>
								<div className={classes.infoContainer}>
									<Grid container spacing={3}>
										<Grid item xs={12} className={classes.infoTitle}>
											{soInfo.delivered_to}
										</Grid>
									</Grid>
									<Grid container spacing={3}>
										<Grid item xs={12} className={classes.infoContent}>
											{soInfo.td_phonenumber}
										</Grid>
									</Grid>
									<Grid container spacing={3}>
										<Grid item xs={12} className={classes.infoContent}>
											{soInfo.email}
										</Grid>
									</Grid>
									<Grid container spacing={3}>
										<Grid item xs={12} className={classes.infoContent}>
										    {soInfo.delivery_address} 
										</Grid>
									</Grid>
									<Grid container spacing={3}>
										<Grid item xs={12} sm={4} className={classes.infoTitle}>
											Shipping Status:
										</Grid>
										<Grid
											item
											xs={12} sm={8}
											className={classes.infoContent}
										>
											{pkgInfo.isdelivered}
										</Grid>
									</Grid>
									<Grid container spacing={3}>
										<Grid item xs={12} sm={4} className={classes.infoTitle}>
											Waybill No:
										</Grid>
										<Grid
											item
											xs={12} sm={8}
											className={classes.infoContent}
										>
										{soInfo.waybill_no}
										</Grid>
									</Grid>
								</div>
							</Grid>

							<Grid item xs={12} sm={6}>
								<h4>Package Details</h4>
								<div className={classes.infoContainer}>
									<Grid container spacing={3}>
										<Grid item xs={12} sm={4} className={classes.infoTitle}>
											Package Name: 
										</Grid>
										<Grid
											item
											xs={12} sm={8}
											className={classes.infoContent}
										>
											{pkgInfo.package_name}
										</Grid>
									</Grid>
									<Grid container spacing={3}>
										<Grid item xs={12} className={classes.infoTitle}>
											Packages Included
										</Grid>
									</Grid>	
									{pkgInfo.package_table ? (<Grid container spacing={3}>
										{pkgInfo.package_table.map((item => {
											return(
											<Grid item xs={12} className={classes.infoContent}>
												{item} 
											</Grid>)
										}))}
									</Grid>	) : (<></>)}	
								</div>

								{activationInfo ? (<>
								<h4>Activation Details</h4>
								<div className={classes.infoContainer}>
									<Grid container spacing={3}>
										<Grid item xs={12} sm={4} className={classes.infoTitle}>
											ID No:
										</Grid>
										<Grid
											item
											xs={12} sm={8}
											className={classes.infoContent}
										>
										{activationInfo.idno}
										</Grid>
									</Grid>		
									<Grid container spacing={3}>
										<Grid item xs={12} sm={4} className={classes.infoTitle}>
											PIN No:
										</Grid>
										<Grid
											item
											xs={12} sm={8}
											className={classes.infoContent}
										>
										************
										</Grid>
									</Grid>	
									<Grid container spacing={3}>
										<Grid item xs={12} sm={4} className={classes.infoTitle}>
											Activation No:
										</Grid>
										<Grid
											item
											xs={12} sm={8}
											className={classes.infoContent}
										>
										************
										</Grid>
									</Grid>	
								</div>
								</>) :(<></>)}
							</Grid>
						</Grid>



						{(flag==='release') ?(<Grid container spacing={1}>
							<Grid item xs={12} sm={6}>
								<Autocomplete
											{...selectLocationProps}
											id="auto-complete-2"
											autoComplete
											includeInputInList
											renderInput={(params) => (
												<TextField
													{...params}
													margin="normal"
													label="Select Warehouse Location"
													variant="outlined"
												/>
											)}onChange={(event, newValue) => {
												if (!newValue == "" || !newValue == null){
													//console.log(newValue.description);
													setWarehouseId(newValue.id);
												}
											}}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<Autocomplete
										{...selectShippingProps}
											style={{marginTop:"1rem"}}
											id="auto-complete-1"
											autoComplete
											includeInputInList
											renderInput={(params) => (
												<TextField
													{...params}
													label="Select Shipping"
													variant="outlined"
												/>
											)}onChange={(event, newValue) => {
												if (!newValue == "" || !newValue == null){
													//console.log(newValue.description);
													setShippingId(newValue.id);
												}
											}}
								/>
							</Grid>
						</Grid>) :(<></>) }


					</CardContent>
				</Card>
					{(flag==='view'||flag==='print') ? (<div className={classes.buttonContainer}>
						{showPDF && <PDFDownloadLink
										document={<JcPortalPackageSales soInfo={soInfo} pkgInfo={pkgInfo} items={pkgInfo.included_packages}/>}
										fileName={"JcPortalPackageSales#"+transaction_no+".pdf"}
										style={{
											textDecoration: "none",
											padding: "6px 8px 8px",
											color: "#fff",
											display:"inline-block",
											marginBottom:"7px",
											fontFamily: "Ubuntu",
											backgroundColor: "#339933",
											border: "1px solid #339933",
											borderRadius: "4px"
											}}
											>
										{({ blob, url, loading, error }) =>
										loading ? "Loading document..." : "Print DR"
										}
						</PDFDownloadLink>}
						<Button style={{marginBottom:"0.5rem"}} variant="contained">Back</Button></div>) : (<div className={classes.buttonContainer}></div>)}

						{(flag==='release') ? (<div className={classes.buttonContainer}>
						<Button  disabled={btnDisabled} onClick={()=>{release_portal_so()}} variant="contained" color="primary">Release</Button>
						<Button  onClick={()=>{history.push('/sales/jcpackagesales')}} variant="contained">Back</Button>
						</div>) : (<div className={classes.buttonContainer}></div>)}

						
						{(flag==='deliver') ? (<div className={classes.buttonContainer}>
						<Button onClick={()=>{deliver_portal_so()}} variant="contained" color="primary">Deliver</Button>
												<Button  onClick={()=>{history.push('/sales/jcpackagesales')}} variant="contained">Back</Button>
						</div>) : (<div className={classes.buttonContainer}></div>)}
			</div>
		) : (<Preloader/>)}

		</div>
	);
};

export default JcPortalPackageSalesView;
